import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/omnitecActions'
import { urlParams } from '../../utils/mainUtils'
import { handleError, handleResponse, securedFetch } from '../apiUtils'
import * as urls from '../urls'

export const fetchOmnitecPrivateRooms = ourId => (dispatch, getState) => {
    dispatch({ type: ActionTypes.OMNITEC_PRIVATE_ROOMS_FETCH_REQUEST })

    const { auth } = getState()

    securedFetch(urlParams(urls.omnitecPrivateRoomsFind, { organizationId: ourId }), auth, { method: 'GET' })
        // fetch(urlParams(urls.omnitecPrivateRoomsFind, { organizationId: ourId }), { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.omnitec_fetchPrivateRoomsSuccess(json)))
        .catch(
            handleError(
                dispatch,
                actions.omnitec_fetchPrivateRoomsFailure,
                'Что-то пошло не так!',
                'При получении замков произошла ошибка'
            )
        )
}

export const fetchOmnitecComonArea = ourId => (dispatch, getState) => {
    dispatch({ type: ActionTypes.OMNITEC_COMMON_AREA_FETCH_REQUEST })

    const { auth } = getState()

    securedFetch(urlParams(urls.omnitecCommonAreaFind, { organizationId: ourId }), auth, { method: 'GET' })
        // fetch(urlParams(urls.omnitecCommonAreaFind, { organizationId: ourId }), { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.omnitec_fetchCommonAreaSuccess(json)))
        .catch(
            handleError(
                dispatch,
                actions.omnitec_fetchCommonAreaFailure,
                'Что-то пошло не так!',
                'При получении замков произошла ошибка'
            )
        )
}

export const createPrivateMapping = params => (dispatch, getState) => {
    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }

    const { auth } = getState()
    securedFetch(urls.createPrivateRoom, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.omnitec_createPrivateRoomsSuccess(json)))
        .catch(
            handleError(
                dispatch,
                actions.omnitec_createPrivateRoomsFailure,
                'Что-то пошло не так!',
                'При получении замков произошла ошибка'
            )
        )
}

export const createCommonMapping = params => (dispatch, getState) => {
    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }

    const { auth } = getState()

    securedFetch(urls.createCommonArea, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.omnitec_createCommonAreaSuccess(json)))
        .catch(
            handleError(
                dispatch,
                actions.omnitec_createCommonAreaFailure,
                'Что-то пошло не так!',
                'При получении замков произошла ошибка'
            )
        )
}

export const deleteCommonMapping = id => (dispatch, getState) => {
    const { auth } = getState()

    securedFetch(urls.omnitecDeleteCommonArea(id), auth, { method: 'DELETE' })
        .then(handleResponse)
        .then(json => dispatch(actions.omnitec_deleteCommonAreaSuccess(id)))
        .catch(
            handleError(
                dispatch,
                actions.omnitec_deleteCommonAreaFailure,
                'Что-то пошло не так!',
                'При получении замков произошла ошибка'
            )
        )
}

export const deletePrivateMapping = id => (dispatch, getState) => {
    const { auth } = getState()

    securedFetch(urls.omnitecDeletePrivateRoom(id), auth, { method: 'DELETE' })
        .then(handleResponse)
        .then(json => dispatch(actions.omnitec_deletePrivateRoomsSuccess(id)))
        .catch(
            handleError(
                dispatch,
                actions.omnitec_deletePrivateRoomsFailure,
                'Что-то пошло не так!',
                'При получении замков произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/omnitecApi/omnitecRooms.js